import { useSelector } from "react-redux";

export function useOrganizations() {
  return useSelector((state) => state.organizations);
}
